import { render, staticRenderFns } from "./DtaPage.vue?vue&type=template&id=21819063&scoped=true&"
import script from "./DtaPage.vue?vue&type=script&lang=js&"
export * from "./DtaPage.vue?vue&type=script&lang=js&"
import style0 from "./DtaPage.vue?vue&type=style&index=0&id=21819063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21819063",
  null
  
)

export default component.exports